<template>
  <LayoutMinimal>
    <div
            id="password_recover"
    >
        <template v-if="$auth.ready()">
          <section class="main">
            <div class="recover-box loadable" :class="{loading}">
              <div class="form">
                <h1 class="title">
                    {{$t('recover_password.title')}}
                </h1>
                <RecoverPasswordForm
                        :email="email"
                        :token="token"
                        :autologin="true"
                        @successfullLogin="successfullLoginHandler"
                        @failedLogin="failedLoginHandler"
                />
                <div class="loader-wrapper">
                  <Spinner/>
                </div>
              </div>
            </div>
          </section>
        </template>
    </div>
    <template slot="after">
      <Footer/>
    </template>
  </LayoutMinimal>
</template>

<script>
    import Spinner from "../components/Spinner";
    import RecoverPasswordForm from "../components/RecoverPasswordForm";
    import LoginForm from "../components/LoginForm";
    import Footer from "../components/Footer";
    import LayoutMinimal from "../layouts/LayoutMinimal";

    export default {
      components: {
        LayoutMinimal,
          LoginForm,
          RecoverPasswordForm,
          Spinner,
          Footer
      },
      data(){
        return {
            email: '',
            token: '',
            loading: true,
            recovered: false,
        }
      },
      methods:{
          checkValidToken(){
              return new Promise((resolve, reject) => {
                  if(this.$route.query.email && this.$route.query.token){
                      resolve(true);
                  }else{
                      reject();
                  }
              })
          },
          successfullLoginHandler(){
            this.$router.push({name: 'home'});
          },
          failedLoginHandler(){
            this.$router.replace({name: 'login'});
          },
      },
      mounted(){
          this.email = this.$route.query.email;
          this.token = this.$route.query.token;

          this.checkValidToken()
            .then((response) => {
                this.loading = false;
            }).catch(() => {
                this.$router.push({name: 'home'});
            })
      },
    }
</script>

<style scoped lang="scss">
  @import '../styles/variables';
  @import '../styles/classes';

  #password_recover {
    background-color: var(--pallete_dark_color);
    display: flex;
    color: var(--pallete_clear_text_color);
    flex-direction: column;
    justify-content: center;
    max-width: 750px;

    section.main {
      justify-content: space-around;
      position: relative;
      margin: 0;

      .recover-box {
        display: flex;
        margin: 0 auto;
        padding: 1.5em;
        background-color: var(--background_01);
        border-radius: 10px;
        margin-left: 1em;
        margin-right: 1em;

        @media(max-width: 450px) {
          border-radius: 0;
          margin-left: 0;
          margin-right: 0;
          padding: .5em;
          width: 100vw;
        }

        .form {
          display: block;
          padding: 1em;
          /*background-color: #000000;*/
          border-radius: 5px;
          width: 100%;

          .title {
            text-align: center;
            width: 100%;
            text-transform: uppercase;
            letter-spacing: 0;
            margin: 0 0 .5em 0;
          }

          @media(max-width: 500px) {
            min-width: auto;
          }
        }
      }
    }
  }
</style>
